import { styled } from '@mui/material/styles';

import { palette } from '../../theme';
import { Icon } from '../Icon';

import { ExpandedProperties } from './SmallExpander.types';

export const StyledTitleContainer = styled('button')`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    color: ${palette.common.blue};
    text-align: center;
    cursor: pointer;
    background: none;
    border: none;
`;

export const StyledTitle = styled('span')`
    margin: 0;
    font-family: thegymgroupsans-headline, serif;
    white-space: nowrap;

    ${({ theme }) => theme.breakpoints.down('mobile')} {
        font-size: 1.2rem;
    }

    ${({ theme }) => theme.breakpoints.up('mobile')} {
        font-size: 1.4rem;
    }
`;

export const StyledIconContainer = styled('div')<ExpandedProperties>`
    position: relative;
    display: inline-block;
    margin-bottom: 0.4rem;
    margin-left: 0.2rem;
    line-height: 0;
    transition: all 0.2s;
    transform: rotate(90deg);
    ${({ $expanded }) => ($expanded ? 'transform: rotate(-90deg);' : '')};
`;

export const StyledIcon = styled(Icon)`
    cursor: pointer;
`;

export const StyledContent = styled('div')<ExpandedProperties>`
    max-height: ${({ $expanded }) => ($expanded ? '15rem' : '0')};
    overflow: hidden;
    font-size: 1.3rem;
    line-height: 1.9rem;
    transition: all 0.7s;
    transition-timing-function: ${({ $expanded }) =>
        $expanded ? 'ease-out' : 'cubic-bezier(0,1,0,1)'};

    ${({ theme }) => theme.breakpoints.down('mobile')} {
        font-size: 1rem;
        line-height: 1.4rem;
    }

    ${({ theme }) => theme.breakpoints.up('mobile')} {
        font-size: 1.4rem;
    }

    p {
        display: flex;
        flex-direction: column;
        margin: 0;

        span:not(:first-of-type) {
            font-family: thegymgroupsans-bold, sans-serif;
        }
    }
`;
